import React, { useState }  from "react";
import { ecoFriendlyImage } from "../../../../../shared/config/constants";
import ToolTipUI            from "../../../../../stories/core-components/ToolTip/ToolTipUI";
import * as S               from "./Reasons.styles";
interface IReason {
  t           : string;
  reasons     : Array<[]>;
  isBluSmart ?: boolean
  h          ?: string
}

const Reason: React.FC<IReason> = ({ t = "", reasons = [], isBluSmart = false, h = "" }) => {
  const [showToolTip, setToolTip] = useState({});
  if (!reasons?.length) return null;
  return (
    <S.Wrapper>
      <S.ReasonTitle>{t}</S.ReasonTitle>
      <S.ReasonTitleWrapper>
        {/* showing bluSmart image and text based on check */}
        {isBluSmart ? (
          <>
            <span className='makeFlex hrtlCenter'>    
              <S.EcoFriendlyImg src={ecoFriendlyImage}/>  
              <strong className='font16 appendLeft10 appendRight5 title'>{h}</strong>
            </span>
          </>
          ) : null
        }
        {reasons?.map(({ data, popup }, index) => (
          <>
            {showToolTip[index] ? (
              <div style={{ position: "relative" }}>
                <ToolTipUI
                  showIcon={false}
                  title={popup?.t}
                  data={popup?.text}
                  bgColor={"#e9f6ea"}
                  borderColor={"#afdfb3"}
                  color={"#2bac36"}
                  iconName={popup?.icon}
                />
              </div>
            ) : null}
            <S.ReasonGradient
              onMouseOver={() => setToolTip({ [index]: true })}
              onMouseOut={() => setToolTip({ [index]: false })}
            >
              {data?.icon ? <img src={data.icon} /> : null}
              <S.ReasonGradientText>{data.t}</S.ReasonGradientText>
            </S.ReasonGradient>
          </>
        )) || []}
      </S.ReasonTitleWrapper>
    </S.Wrapper>
  );
};

export default Reason;
